<template>
  <div id="filters_col">
    <a
      data-toggle="collapse"
      href="#collapseFilters"
      aria-expanded="false"
      aria-controls="collapseFilters"
      id="filters_col_bt"
      >Filters
    </a>
    <div class="collapse show" id="collapseFilters">
      <div class="filter_type">
        <h6>Occasion</h6>

        <select
          name=""
          class="form-control select2"
          id="category"
          v-model="search.event"
          @change="() => loadNearbyOffers(search)"
        >
          <option value="" selected>Select Occasion</option>
          <option value="birthday">BirthDay</option>
          <option value="anniversary">Anniversary</option>
          <option value="party">Party</option>
          <option value="engagement">Engagement</option>
          <option value="baby-shower">Baby-shower</option>
          <option value="farewell">Farewell</option>
          <option value="retirement">Retirement</option>
          <option value="others">Others</option>
        </select>
      </div>
      <div class="filter_type">
        <h6>Pincode</h6>
        <input
          type="text"
          id="pincode"
          name="pincode"
          v-model="search.pincode"
          @keyup="() => loadNearbyOffers(search)"
          class="form-control"
        />
      </div>
      <div class="filter_type">
        <h6>Location</h6>

        <vue-simple-suggest
          v-model="search.location"
          display-attribute="name"
          value-attribute="url"
          :list="getSuggestionList"
          @select="getvalue($event)"
        >
        </vue-simple-suggest>
       <a href="javascript:void(0);" @click="currentLoc()"> <i class="icon_pin_alt" > </i> Use Current Location</a> 
        <!-- <input type="range" class="form-range mt-4" list="tickmarks" min="0" max="20" v-model="search.range" />
          {{search.range+ "Km"}} -->
      </div>
      <!-- <div class="filter_type" v-show="subCatList.length > 0">
        <h6>Sub Categories</h6>
        <ul>
          <li v-for="cat in subCatList" :key="cat.id">
            <label class="container_check" v-if="cat.category != ''"
              >{{ cat.category }}
              <input
                type="checkbox"
                :value="cat.id"
                v-model="search.subcategories"
                @click="() => loadNearbyOffers(search)"
              />{{ cat.text }}
              <span class="checkmark"></span>
            </label>
          </li>
        </ul>
      </div> -->
      <div class="filter_type">
        <h6>Categories</h6>
        <select2-multiple-control
          :options="catList"
          :settings="{
            multiple: true,
          }"
          multiple
          @select="catSelectEvent($event)"
        />

        <h6>Sub Categories</h6>
        <select2-multiple-control
          :options="subCatList"
          :settings="{ multiple: true }"
          @select="subcatselectEvent($event)"
          placeholder="-Select Categories-"
        />
      </div>
      <!--<div class="filter_type">
        <h6>Rating</h6>
        <ul>
          <li>
            <label class="container_check"
              >Superb 9+ <small>(25)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Very Good 8+ <small>(26)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Good 7+ <small>(25)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Pleasant 6+ <small>(12)</small>
              <input
                type="checkbox"
                @click="() => loadNearbyOffers(search)"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
        </ul>
      </div>-->
    </div>
    <!--/filters col-->
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

import API from "../services/index";
// import { EventBus } from "@/EventBus.js";
export default {
  props: [
    "search",
    "loadNearbyOffers",
    "catList",
    "subCatList",
    "searchcat",
    "catSelectEvent",
    "subcatselectEvent",
  ],
  components: {
    VueSimpleSuggest,
  },
  methods: {
    currentLoc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        this.error = "Geolocation is not supported.";
      }
    },
    showPosition(position) {
      position.coords.latitude;
      position.coords.longitude;
      var location = [position.coords.latitude, position.coords.longitude];
      this.SuggestionList(location);
    },
    SuggestionList(location) {
      var i = [];
      // if (this.search.location.length >= 2) {
      API.get(
        `https://location.securebrandtech.com/auto/api?q=india&lat=${location[0]}&lon=${location[1]}`
      )
        .then((response) => {
          response.data.features.forEach(function (feature) {
            i.push(
              feature.properties.name + " " + feature.properties.county
                ? feature.properties.county
                : "" + " " + " " + feature.properties.state
                ? feature.properties.state
                : "" + " " + feature.properties.postcode
                ? feature.properties.postcode
                : ""
            );
          });
          var uniq = [...new Set(i)];
                      return uniq;

        })

        .catch(function (error) {
          console.log(error);
        });
    },
    getSuggestionList() {
      var i = [];
        return API.get(
          `https://location.securebrandtech.com/auto/api?q=${this.search.location}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];

            return uniq;
         
          })

          .catch(function (error) {
            console.log(error);
          });
      
    },
    getvalue(value){
      // var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then( (response)=> {
         var j =0 ;
          response.data.features.forEach( (feature)=> {
            if(j === 0){
               this.search.geocodes = feature.geometry.coordinates
            // i= feature.geometry.coordinates;
            }
           j++;
          });
          this.loadNearbyOffers(this.search)
        })
        .catch(function (error) {
          console.log(error);
        });  
        
    }
  },
};
</script>